import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";
import { ActionDrawerApi } from "../models/action-drawer-api";

@Injectable()
export class ActionDrawerService implements ActionDrawerApi {

  private readonly resetZoomSubject = new Subject<void>();
  private readonly zoomDisabledBS = new BehaviorSubject<boolean>(false);
  readonly resetZoom$ = this.resetZoomSubject.asObservable();
  readonly zoomDisabled$ = this.zoomDisabledBS.asObservable();

  resetZoom(): void {
    this.resetZoomSubject.next();
  }

  disableZoom(): void {
    this.zoomDisabledBS.next(true);
  }

  enableZoom(): void {
    this.zoomDisabledBS.next(false);
  }
}
